import { render } from "./Categories-add.vue?vue&type=template&id=aa500366"
import script from "./Categories-add.vue?vue&type=script&lang=js"
export * from "./Categories-add.vue?vue&type=script&lang=js"

import "./Categories-add.vue?vue&type=style&index=0&id=aa500366&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__